(() => {
  const config = window.hopshopSubscriptionConfig || {};
  const pendingKey = 'hopshopPendingSubscription';
  const pendingMobileKey = 'hopshopPendingMobilePhone';
  const justRegisteredKey = 'hopshopJustRegisteredAt';
  const popupDismissKey = 'hopshopJazzCashPopupDismissedAt';
  const openAfterProfileSaveKey = 'hopshopOpenPlansAfterProfileSave';
  const proActiveKey = 'hopshopProActive';
  const awaitingReturnKey = 'hopshopAwaitingSubscriptionReturn';
  const subscriptionPlanUrls = {
    monthly: 'http://payments.hopshop.pk/landingjazzcash?plan_id=1',
    six_months: 'http://payments.hopshop.pk/landingjazzcash?plan_id=2',
    yearly: 'http://payments.hopshop.pk/landingjazzcash?plan_id=3'
  };
  const getStoredMobileKey = () => {
    return `hopshopCustomerMobile:${config.customerEmail || config.customerId || 'guest'}`;
  };

  const getFallbackStoredMobile = () => {
    try {
      return localStorage.getItem(pendingMobileKey) || '';
    } catch (error) {
      return '';
    }
  };

  const normalizePhone = (countryCode = '', mobile = '') => {
    const code = String(countryCode || '').replace(/[^\d+]/g, '');
    let digits = String(mobile || '').replace(/\D/g, '');

    if (!digits && code && /^\+?\d+$/.test(code)) {
      return code.startsWith('+') ? code : `+${code}`;
    }

    digits = digits.replace(/^0+/, '');

    if (!digits) {
      return '';
    }

    if (String(mobile || '').trim().startsWith('+')) {
      return `+${digits}`;
    }

    if (!code) {
      return `+${digits}`;
    }

    return `${code.startsWith('+') ? code : `+${code}`}${digits}`;
  };

  const getCustomerAccountPhone = () => {
    return normalizePhone('', config.customerPhone || '')
      || normalizePhone('', config.customerNotePhone || '')
      || normalizePhone('', getFallbackStoredMobile());
  };

  const getStoredCustomerPhone = () => {
    let locallyStoredPhone = '';

    try {
      locallyStoredPhone = localStorage.getItem(getStoredMobileKey()) || '';
    } catch (error) {
      locallyStoredPhone = '';
    }

    return getCustomerAccountPhone()
      || normalizePhone('', getFallbackStoredMobile())
      || normalizePhone('', locallyStoredPhone);
  };

  const getPreviewThemeId = () => {
    try {
      return new URLSearchParams(window.location.search).get('preview_theme_id') || '';
    } catch (error) {
      return '';
    }
  };

  const withPreviewContext = (url, extraParams = {}) => {
    const resolvedUrl = new URL(url, window.location.origin);
    const previewThemeId = getPreviewThemeId();

    if (previewThemeId) {
      resolvedUrl.searchParams.set('preview_theme_id', previewThemeId);
    }

    Object.entries(extraParams).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        resolvedUrl.searchParams.set(key, value);
      }
    });

    return resolvedUrl.toString();
  };

  const createSessionId = () => {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') {
      return `hopshop-${window.crypto.randomUUID()}`;
    }

    return `hopshop-${Date.now()}-${Math.random().toString(16).slice(2, 10)}`;
  };

  const detectTrafficSource = () => {
    const params = new URLSearchParams(window.location.search);
    const medium = (params.get('utm_medium') || '').toLowerCase();
    const source = (params.get('utm_source') || '').toLowerCase();

    if (source.includes('facebook') || source.includes('instagram') || source.includes('google') || source.includes('tiktok')) {
      return 'ad';
    }

    if (medium.includes('cpc') || medium.includes('paid') || medium.includes('ppc') || medium.includes('ads')) {
      return 'ad';
    }

    if (document.referrer && !document.referrer.includes(window.location.hostname)) {
      return 'referral';
    }

    return 'organic';
  };

  const buildJazzCashUrl = (planKey = 'monthly') => {
    if (planKey === 'weekly') {
      return '';
    }

    const baseUrl = subscriptionPlanUrls[planKey]
      || config.landingUrl
      || 'http://payments.hopshop.pk/landingjazzcash?plan_id=1';

    const redirectToAccount = withPreviewContext(config.profileUrl || '/account', { subscription_return: '1' });
    const resolvedUrl = new URL(baseUrl, window.location.origin);

    if (!resolvedUrl.searchParams.has('return_url')) {
      resolvedUrl.searchParams.set('return_url', redirectToAccount);
    }
    if (!resolvedUrl.searchParams.has('redirect_url')) {
      resolvedUrl.searchParams.set('redirect_url', redirectToAccount);
    }
    if (!resolvedUrl.searchParams.has('callback_url')) {
      resolvedUrl.searchParams.set('callback_url', redirectToAccount);
    }

    return resolvedUrl.toString();
  };

  const readPendingSubscription = () => {
    try {
      return JSON.parse(localStorage.getItem(pendingKey) || 'null');
    } catch (error) {
      return null;
    }
  };

  const writePendingSubscription = (planKey = '') => {
    localStorage.setItem(
      pendingKey,
      JSON.stringify({
        createdAt: Date.now(),
        planKey,
        returnPath: window.location.pathname + window.location.search
      })
    );
  };

  const clearPendingSubscription = () => {
    localStorage.removeItem(pendingKey);
  };

  const markAwaitingSubscriptionReturn = (planKey = '') => {
    try {
      localStorage.setItem(awaitingReturnKey, JSON.stringify({
        createdAt: Date.now(),
        planKey
      }));
    } catch (error) {
      /* no-op */
    }
  };

  const readAwaitingSubscriptionReturn = () => {
    try {
      return JSON.parse(localStorage.getItem(awaitingReturnKey) || 'null');
    } catch (error) {
      return null;
    }
  };

  const clearAwaitingSubscriptionReturn = () => {
    try {
      localStorage.removeItem(awaitingReturnKey);
    } catch (error) {
      /* no-op */
    }
  };

  const openSubscriptionPopupWithPlans = () => {
    const popup = document.querySelector('[data-hopshop-subscription-popup]');
    if (!popup) return false;

    const popupIntro = popup.querySelector('[data-hopshop-popup-intro]');
    const popupPlanSelector = popup.querySelector('[data-hopshop-popup-plan-selector]');
    const popupProceedButton = popup.querySelector('[data-hopshop-proceed-selected-plan]');

    popup.hidden = false;
    document.body.classList.add('hopshop-subscription-popup-open');
    popup.classList.add('is-selecting-plan');

    if (popupIntro) {
      popupIntro.hidden = true;
    }

    if (popupPlanSelector) {
      popupPlanSelector.hidden = false;
    }

    if (popupProceedButton) {
      popupProceedButton.hidden = true;
      popupProceedButton.disabled = true;
      popupProceedButton.textContent = 'Continue to Payment';
    }

    popup.querySelectorAll('[data-hopshop-popup-plan-option]').forEach((button) => {
      button.classList.remove('is-selected');
    });

    const monthlyButton = popup.querySelector('[data-hopshop-popup-plan-option][data-plan-key="monthly"]');
    if (monthlyButton) {
      monthlyButton.click();
    }

    return true;
  };

  const showFeedback = (element, message, type = '') => {
    if (!element) return;
    element.hidden = false;
    element.textContent = message;
    element.classList.remove('is-success', 'is-error');
    if (type) element.classList.add(type);
  };

  const hideFeedback = (element) => {
    if (!element) return;
    element.hidden = true;
    element.textContent = '';
    element.classList.remove('is-success', 'is-error');
  };

  const customerHasActiveTag = () => {
    const rawTags = config.customerTags || '';
    const tags = Array.isArray(rawTags)
      ? rawTags
      : String(rawTags).split(',');

    return tags.some((tag) => String(tag || '').trim().toLowerCase() === 'jazzcash_active');
  };

  const setProActiveState = (isActive) => {
    const proBadge = document.querySelector('[data-hopshop-pro-badge]');
    if (proBadge) {
      proBadge.hidden = !isActive;
    }

    try {
      if (isActive) {
        localStorage.setItem(proActiveKey, '1');
      } else {
        localStorage.removeItem(proActiveKey);
      }
    } catch (error) {
      /* no-op */
    }
  };

  const startSubscription = (planKey = 'monthly') => {
    if (!config.customerLoggedIn) {
      writePendingSubscription(planKey);
      window.location.href = withPreviewContext(config.loginUrl || '/account/login');
      return;
    }

    if (!getCustomerAccountPhone()) {
      writePendingSubscription(planKey);
      window.location.href = withPreviewContext(config.profileUrl || '/account', { hopshop_subscription: '1' });
      return;
    }

    clearPendingSubscription();

    if (planKey === 'weekly') {
      return;
    }

    try {
      localStorage.setItem(popupDismissKey, String(Date.now()));
    } catch (error) {
      /* no-op */
    }

    markAwaitingSubscriptionReturn(planKey);

    window.location.href = buildJazzCashUrl(planKey);
  };

  const findValueByKeys = (source, keys) => {
    if (!source || typeof source !== 'object') return '';

    const search = (node) => {
      if (!node || typeof node !== 'object') return '';

      for (const key of keys) {
        if (Object.prototype.hasOwnProperty.call(node, key) && node[key] !== null && node[key] !== undefined && node[key] !== '') {
          return String(node[key]);
        }
      }

      for (const value of Object.values(node)) {
        if (value && typeof value === 'object') {
          const found = search(value);
          if (found) return found;
        }
      }

      return '';
    };

    return search(source);
  };

  const initPopup = () => {
    const popup = document.querySelector('[data-hopshop-subscription-popup]');
    if (!popup) return;
    const popupFeedbackTarget = popup.querySelector('[data-hopshop-popup-feedback]');
    const popupIntro = popup.querySelector('[data-hopshop-popup-intro]');
    const popupSubscribeButton = popup.querySelector('[data-hopshop-popup-subscribe]');
    const popupBackButton = popup.querySelector('[data-hopshop-popup-back]');
    const popupPlanSelector = popup.querySelector('[data-hopshop-popup-plan-selector]');
    const popupProceedButton = popup.querySelector('[data-hopshop-proceed-selected-plan]');
    const planLabels = {
      monthly: 'Monthly Rs 499',
      six_months: '6 Months Rs 1199',
      yearly: '1 Year Rs 1999'
    };
    let selectedPlanKey = '';
    const pending = readPendingSubscription();

    let justRegisteredAt = 0;
    try {
      justRegisteredAt = Number(localStorage.getItem(justRegisteredKey) || '0');
    } catch (error) {
      justRegisteredAt = 0;
    }

    const freshRegistrationWindow = 30 * 60 * 1000;
    const isFreshRegistration = justRegisteredAt && (Date.now() - justRegisteredAt < freshRegistrationWindow);

    const setPlanStep = (isOpen) => {
      if (popupPlanSelector) {
        popupPlanSelector.hidden = !isOpen;
      }

      if (popupIntro) {
        popupIntro.hidden = isOpen;
      }

      popup.classList.toggle('is-selecting-plan', isOpen);

      if (!isOpen) {
        selectedPlanKey = '';

        if (popupProceedButton) {
          popupProceedButton.hidden = true;
          popupProceedButton.disabled = true;
          popupProceedButton.textContent = 'Continue to Payment';
        }

        popup.querySelectorAll('[data-hopshop-popup-plan-option]').forEach((button) => {
          button.classList.remove('is-selected');
        });

        hideFeedback(popupFeedbackTarget);
      } else {
        hideFeedback(popupFeedbackTarget);
        const monthlyButton = popup.querySelector('[data-hopshop-popup-plan-option][data-plan-key="monthly"]');
        if (monthlyButton) {
          monthlyButton.click();
        }
      }
    };

    const showPopup = () => {
      popup.hidden = false;
      document.body.classList.add('hopshop-subscription-popup-open');
    };

    const hidePopup = () => {
      popup.hidden = true;
      setPlanStep(false);
      document.body.classList.remove('hopshop-subscription-popup-open');
      localStorage.setItem(popupDismissKey, String(Date.now()));
    };

    popup.querySelectorAll('[data-hopshop-close-popup]').forEach((trigger) => {
      trigger.addEventListener('click', hidePopup);
    });

    const dismissedAt = Number(localStorage.getItem(popupDismissKey) || '0');
    const oneDay = 24 * 60 * 60 * 1000;

    if (popupSubscribeButton) {
      popupSubscribeButton.addEventListener('click', () => {
        hideFeedback(popupFeedbackTarget);

        if (!config.customerLoggedIn) {
          writePendingSubscription('');
          window.location.href = withPreviewContext(config.loginUrl || '/account/login');
          return;
        }

        if (!getCustomerAccountPhone()) {
          writePendingSubscription('');
          window.location.href = withPreviewContext(config.profileUrl || '/account', { hopshop_subscription: '1' });
          return;
        }

        setPlanStep(true);
      });
    }

    if (popupBackButton) {
      popupBackButton.addEventListener('click', () => {
        setPlanStep(false);
      });
    }

    popup.querySelectorAll('[data-hopshop-popup-plan-option]').forEach((button) => {
      button.addEventListener('click', () => {
        const planKey = button.getAttribute('data-plan-key') || 'monthly';

        if (planKey === 'weekly') {
          showFeedback(popupFeedbackTarget, 'Weekly package is coming soon. Please choose Monthly, 6 Months, or 1 Year for now.', 'is-error');
          return;
        }

        selectedPlanKey = planKey;
        popup.querySelectorAll('[data-hopshop-popup-plan-option]').forEach((planButton) => {
          planButton.classList.toggle('is-selected', planButton === button);
        });

        if (popupProceedButton) {
          popupProceedButton.hidden = false;
          popupProceedButton.disabled = false;
          popupProceedButton.textContent = `Proceed with ${planLabels[planKey] || 'selected package'}`;
        }
      });
    });

    if (popupProceedButton) {
      popupProceedButton.addEventListener('click', () => {
        if (!selectedPlanKey) {
          showFeedback(popupFeedbackTarget, 'Please select a package first.', 'is-error');
          return;
        }

        if (!config.customerLoggedIn) {
          writePendingSubscription(selectedPlanKey);
          window.location.href = withPreviewContext(config.loginUrl || '/account/login');
          return;
        }

        hideFeedback(popupFeedbackTarget);
        startSubscription(selectedPlanKey);
      });
    }

    if (!config.showPopupOnLoad) {
      return;
    }

    // Never show popup to logged-in users who already have a phone saved — they
    // have been through the subscription flow at least once.
    if (config.customerLoggedIn && getCustomerAccountPhone() && !pending && !isFreshRegistration) return;

    if (dismissedAt && Date.now() - dismissedAt < oneDay && !pending && !isFreshRegistration) {
      return;
    }

    window.setTimeout(() => {
      showPopup();

      if (pending && config.customerLoggedIn && getCustomerAccountPhone()) {
        setPlanStep(true);
      } else {
        setPlanStep(false);
      }
    }, 1800);
  };

  const syncPreviewAwareAccountLinks = () => {
    const previewThemeId = getPreviewThemeId();
    if (!previewThemeId) return;

    // Only update <a> href links — never modify form actions because third-party
    // auth apps (e.g. AVADA) read form.action for their post-login redirect and
    // will loop back to the login page if it contains preview_theme_id.
    document.querySelectorAll('a[href]').forEach((link) => {
      const href = link.getAttribute('href');
      if (!href || href.startsWith('#')) return;

      const resolvedUrl = new URL(href, window.location.origin);
      if (/\/account(\/|$)/.test(resolvedUrl.pathname)) {
        resolvedUrl.searchParams.set('preview_theme_id', previewThemeId);
        link.setAttribute('href', `${resolvedUrl.pathname}${resolvedUrl.search}${resolvedUrl.hash}`);
      }
    });
  };

  const initSubscriptionButtons = () => {
    document.querySelectorAll('[data-hopshop-start-subscription]').forEach((button) => {
      button.addEventListener('click', startSubscription);
    });
  };

  const initMobileForms = () => {
    document.querySelectorAll('form').forEach((form) => {
      const country = form.querySelector('[data-hopshop-country-code]');
      const mobile = form.querySelector('[data-hopshop-mobile-number]');
      const fullPhone = form.querySelector('[data-hopshop-full-phone]');
      const customerNote = form.querySelector('[data-hopshop-customer-note]');
      
      // For customer_address forms (account page mobile update), we may need to re-open plan popup after save.
      const isAddressForm = form.id && form.id.includes('MobileUpdate');

      if (!country || !mobile || !fullPhone) return;

      // Defensive: ensure Pakistan (+92) is the default selection if the dropdown is empty
      if (!country.value) {
        country.value = '+92';
      }

      const currentPhone = fullPhone.value || '';

      if (currentPhone && !mobile.value) {
        const stripped = currentPhone.replace(/\s+/g, '');
        const match = stripped.match(/^(\+\d{1,4})(\d+)$/);

        if (match) {
          country.value = match[1];
          mobile.value = match[2];
          fullPhone.value = normalizePhone(match[1], match[2]);
        } else {
          mobile.value = stripped.replace(/^\+/, '');
          fullPhone.value = normalizePhone('', stripped);
        }
      }

      const syncPhone = () => {
        const normalized = normalizePhone(country.value, mobile.value);
        fullPhone.value = normalized;

        if (customerNote) {
          customerNote.value = normalized
            ? `Mobile Phone: ${normalized}\nProfile Source: Hopshop JazzCash registration`
            : '';
        }

        if (normalized) {
          try {
            localStorage.setItem(pendingMobileKey, normalized);
            localStorage.setItem(getStoredMobileKey(), normalized);
          } catch (error) {
            /* no-op */
          }
        }

        if (!normalized) {
          mobile.setCustomValidity('Please enter a valid mobile number.');
        } else {
          mobile.setCustomValidity('');
        }
      };

      country.addEventListener('change', syncPhone);
      mobile.addEventListener('input', syncPhone);
      syncPhone();

      form.addEventListener('submit', (event) => {
        syncPhone();

        if (!fullPhone.value) {
          event.preventDefault();
          mobile.reportValidity();
        }        
        const isCreateCustomerForm = fullPhone.name === 'customer[note]';
        if (isCreateCustomerForm && fullPhone.value) {
          try {
            localStorage.setItem(justRegisteredKey, String(Date.now()));
          } catch (error) {
            /* no-op */
          }
        }

        if (isAddressForm) {
          try {
            const hasPending = !!readPendingSubscription();
            const params = new URLSearchParams(window.location.search);
            const fromSubscriptionFlow = params.get('hopshop_subscription') === '1';

            if (hasPending || fromSubscriptionFlow) {
              localStorage.setItem(openAfterProfileSaveKey, '1');
            }
          } catch (error) {
            /* no-op */
          }

          // Trigger an immediate status check with the NEW mobile so the backend
          // re-evaluates the customer's subscription tag right away (not just on
          // next /account visit). Fire-and-forget with keepalive so it completes
          // even though the form submit will navigate away.
          if (config.customerId && fullPhone.value) {
            try {
              const newMsisdn = String(fullPhone.value || '')
                .replace(/^\+/, '')
                .replace(/^92/, '')
                .replace(/^0+/, '');

              if (newMsisdn) {
                fetch((config.baseUrl || 'https://subscription.hopshop.pk') + '/api/subscription/status', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  keepalive: true,
                  body: JSON.stringify({
                    msisdn: newMsisdn,
                    shopify_customer_id: String(config.customerId),
                    shopify_customer_email: config.customerEmail || '',
                    ensure_tag_sync: true,
                    active_tag: 'jazzcash_active',
                    inactive_tag: 'jazzcash_active',
                    source_channel: 'mobile_update'
                  })
                }).catch(() => { /* fire-and-forget */ });
              }
            } catch (error) {
              /* no-op */
            }
          }
        }
      });
    });
  };

  const parseStatusLabel = (data) => {
    // 1. Check isSubscribed boolean directly — most reliable source
    // Search result object from both wrapped (data.raw.result) and unwrapped (data.result) responses
    const resultNode = (data && data.raw && data.raw.result) || (data && data.result) || null;
    if (resultNode && typeof resultNode.isSubscribed === 'boolean') {
      return resultNode.isSubscribed ? 'Active' : 'Inactive';
    }

    // 2. Check outer "status" field set by our Laravel proxy wrapper
    if (data && typeof data.status === 'string') {
      const s = data.status.toLowerCase();
      if (s === 'active') return 'Active';
      if (s === 'inactive') return 'Inactive';
    }

    // 3. Fallback: text scan (avoids matching "subscribed" inside "isSubscribed: false")
    const text = JSON.stringify(data || {}).toLowerCase();
    if (
      text.includes('"issubscribed":false')
      || text.includes('inactive')
      || text.includes('unsubscribed')
      || text.includes('not subscribed')
      || text.includes('not active')
    ) {
      return 'Inactive';
    }
    if (
      text.includes('"issubscribed":true')
      || /(^|[^a-z])active([^a-z]|$)/.test(text)
      || text.includes('success')
    ) {
      return 'Active';
    }

    return 'Pending review';
  };

  const requestSubscriptionApi = async (endpoint) => {
    let phone = getCustomerAccountPhone();
    
    // Strip country code: convert "+923343594375" or "923343594375" to "3343594375"
    const msisdn = phone
      .replace(/^\+/, '')           // Remove leading +
      .replace(/^92/, '')           // Remove Pakistan country code (92)
      .replace(/^0+/, '');          // Remove leading zeros

    if (!msisdn) {
      throw new Error('A saved mobile number is required before checking subscription status.');
    }

    const response = await fetch(`${config.baseUrl || 'https://subscription.hopshop.pk'}${endpoint}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        msisdn,
        shopify_customer_id: String(config.customerId || ''),
        shopify_customer_email: config.customerEmail || '',
        ensure_tag_sync: true,
        active_tag: 'jazzcash_active',
        inactive_tag: 'jazzcash_active',
        source_channel: detectTrafficSource(),
        page_path: window.location.pathname
      })
    });

    const text = await response.text();
    let data;

    try {
      data = text ? JSON.parse(text) : {};
    } catch (error) {
      data = { raw: text };
    }

    if (!response.ok) {
      throw new Error(data.message || text || `Request failed with status ${response.status}`);
    }

    return data;
  };

  const initAccountSubscriptionCard = () => {
    const card = document.querySelector('[data-hopshop-subscription-card]');
    if (!card) return;

    const statusTarget = card.querySelector('[data-hopshop-subscription-status]');
    const feedbackTarget = card.querySelector('[data-hopshop-subscription-feedback]');
    const refreshButton = card.querySelector('[data-hopshop-refresh-status]');
    const unsubscribeButton = card.querySelector('[data-hopshop-unsubscribe]');
    const openPlanSelectorButton = card.querySelector('[data-hopshop-open-plan-selector]');
    const planSelector = card.querySelector('[data-hopshop-plan-selector]');
    const intervalTarget = card.querySelector('[data-hopshop-subscription-interval]');
    const expiryTarget = card.querySelector('[data-hopshop-subscription-expiry]');

    const applyStatusUi = (label) => {
      if (!card) return;
      const subscribeBtn = card.querySelector('[data-hopshop-start-subscription]');
      const isActive = label === 'Active';

      setProActiveState(isActive);

      if (subscribeBtn) subscribeBtn.hidden = isActive;
      if (unsubscribeButton) {
        unsubscribeButton.hidden = !isActive;
        unsubscribeButton.disabled = !isActive;
      }

      if (openPlanSelectorButton) {
        openPlanSelectorButton.hidden = isActive;
      }

      if (planSelector && isActive) {
        planSelector.hidden = true;
      }
    };

    const formatDate = (raw) => {
      if (!raw || raw === 'null') return '--';
      try {
        const d = new Date(raw);
        if (isNaN(d.getTime())) return raw;
        return d.toLocaleDateString('en-PK', { year: 'numeric', month: 'long', day: 'numeric' });
      } catch (e) {
        return raw;
      }
    };

    const formatInterval = (raw) => {
      if (!raw || raw === '--') return '--';
      // "MONTHLY" → "Monthly", "SIX_MONTHS" → "6 Months", etc.
      const map = {
        monthly: 'Monthly',
        weekly: 'Weekly',
        yearly: 'Yearly',
        annual: 'Annual',
        six_months: '6 Months',
        sixmonths: '6 Months',
        '6months': '6 Months',
        '6_months': '6 Months'
      };
      const key = String(raw).toLowerCase().replace(/[^a-z0-9]/g, '');
      return map[key] || (String(raw).charAt(0).toUpperCase() + String(raw).slice(1).toLowerCase());
    };

    const billingDateTarget = card.querySelector('[data-hopshop-subscription-billing]');

    const applyStatusMeta = (data) => {
      const rawInterval = findValueByKeys(data, ['interval', 'plan_interval', 'duration', 'package_interval']);
      const rawExpiry   = findValueByKeys(data, ['expiry_date', 'expiryDate', 'expires_at', 'expiry', 'end_date']);
      const rawBilling  = findValueByKeys(data, ['lastBillingDate', 'last_billing_date', 'billing_date', 'lastbillingdate']);

      if (intervalTarget)    intervalTarget.textContent    = formatInterval(rawInterval || '--');
      if (expiryTarget)      expiryTarget.textContent      = formatDate(rawExpiry || '--');
      if (billingDateTarget) billingDateTarget.textContent = formatDate(rawBilling || '--');
    };

    const refreshStatus = async () => {
      hideFeedback(feedbackTarget);

      if (statusTarget) {
        statusTarget.textContent = getCustomerAccountPhone() ? 'Checking…' : 'Mobile number required';
      }

      if (!getCustomerAccountPhone()) {
        showFeedback(feedbackTarget, 'Please add your mobile number first, then refresh the subscription status.', 'is-error');
        return;
      }

      try {
        const data = await requestSubscriptionApi('/api/subscription/status');
        const label = parseStatusLabel(data);
        if (statusTarget) statusTarget.textContent = label;
        applyStatusMeta(data);
        applyStatusUi(label);
        showFeedback(feedbackTarget, 'Subscription status updated successfully.', 'is-success');
      } catch (error) {
        if (statusTarget) statusTarget.textContent = 'Unable to verify';
        if (intervalTarget) intervalTarget.textContent = '--';
        if (expiryTarget) expiryTarget.textContent = '--';
        if (billingDateTarget) billingDateTarget.textContent = '--';
        showFeedback(feedbackTarget, error.message || 'Could not reach the JazzCash API.', 'is-error');
      } finally {
        // We reached account and attempted a fresh status pull, so stop forcing return routing.
        clearAwaitingSubscriptionReturn();
      }
    };

    if (openPlanSelectorButton) {
      openPlanSelectorButton.addEventListener('click', () => {
        if (!getCustomerAccountPhone()) {
          showFeedback(feedbackTarget, 'Please save your mobile number below before selecting a JazzCash package.', 'is-error');
          const mobileSection = document.getElementById('HopshopMobileUpdateForm');
          if (mobileSection) {
            mobileSection.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
          return;
        }

        if (planSelector) {
          planSelector.hidden = true;
        }

        if (!openSubscriptionPopupWithPlans()) {
          showFeedback(feedbackTarget, 'Could not open the package popup. Please refresh and try again.', 'is-error');
        }
      });
    }

    card.querySelectorAll('[data-hopshop-plan-option]').forEach((button) => {
      button.addEventListener('click', () => {
        const planKey = button.getAttribute('data-plan-key') || 'monthly';

        if (planKey === 'weekly') {
          showFeedback(feedbackTarget, 'Weekly package is coming soon. Please choose Monthly, 6 Months, or 1 Year for now.', 'is-error');
          return;
        }

        startSubscription(planKey);
      });
    });

    if (refreshButton) {
      refreshButton.addEventListener('click', refreshStatus);
    }

    if (unsubscribeButton) {
      unsubscribeButton.addEventListener('click', async () => {
        if (!window.confirm('Are you sure you want to unsubscribe this mobile number from Hopshop JazzCash updates?')) {
          return;
        }

        try {
          unsubscribeButton.disabled = true;
          const data = await requestSubscriptionApi('/api/subscription/unsubscribe');
          if (statusTarget) statusTarget.textContent = 'Unsubscribed';
          if (intervalTarget) intervalTarget.textContent = '--';
          if (expiryTarget) expiryTarget.textContent = '--';
          if (billingDateTarget) billingDateTarget.textContent = '--';
          applyStatusUi('Unsubscribed');
          showFeedback(feedbackTarget, data.message || 'The unsubscribe request has been submitted.', 'is-success');
        } catch (error) {
          showFeedback(feedbackTarget, error.message || 'Could not unsubscribe the current mobile number.', 'is-error');
        } finally {
          unsubscribeButton.disabled = false;
        }
      });
    }

    const params = new URLSearchParams(window.location.search);
    // Detect return from JazzCash either via explicit param or HTTP referrer
    const fromJazzCash = params.get('subscription_return') === '1'
      || (document.referrer && document.referrer.includes('payments.hopshop.pk'));

    if (fromJazzCash) {
      showFeedback(feedbackTarget, 'Welcome back! Checking your subscription status with JazzCash…', 'is-success');
      // Scroll card into view so user sees the confirmation immediately
      card.scrollIntoView({ behavior: 'smooth', block: 'center' });
    } else if (params.get('hopshop_subscription') === '1' && !getCustomerAccountPhone()) {
      showFeedback(feedbackTarget, 'Please save your mobile number below before continuing to JazzCash.', 'is-error');
      const mobileSection = document.getElementById('HopshopMobileUpdateForm');
      if (mobileSection) {
        mobileSection.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }

    refreshStatus();
  };

  const initCustomerAuthForms = () => {
    const params = new URLSearchParams(window.location.search);
    const registerSuccessMessage = document.querySelector('[data-hopshop-register-success]');

    if (registerSuccessMessage && params.get('registered') === '1') {
      registerSuccessMessage.hidden = false;
    }
  };

  const handlePendingAfterLogin = () => {
    const pending = readPendingSubscription();
    let openAfterProfileSave = false;
    try {
      openAfterProfileSave = localStorage.getItem(openAfterProfileSaveKey) === '1';
    } catch (error) {
      openAfterProfileSave = false;
    }

    if ((!pending && !openAfterProfileSave) || !config.customerLoggedIn) return;

    if (window.location.pathname !== (config.profileUrl || '/account')) {
      window.location.href = withPreviewContext(config.profileUrl || '/account', { hopshop_subscription: '1' });
      return;
    }

    const planSelector = document.querySelector('[data-hopshop-plan-selector]');
    const feedbackTarget = document.querySelector('[data-hopshop-subscription-feedback]');

    if (!getCustomerAccountPhone()) {
      showFeedback(feedbackTarget, 'Please save your mobile number below before choosing a JazzCash package.', 'is-error');
      const mobileSection = document.getElementById('HopshopMobileUpdateForm');
      if (mobileSection) {
        mobileSection.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      return;
    }

    if (planSelector) {
      planSelector.hidden = true;
    }

    clearPendingSubscription();
    try {
      localStorage.removeItem(openAfterProfileSaveKey);
    } catch (error) {
      /* no-op */
    }

    if (!openSubscriptionPopupWithPlans()) {
      showFeedback(feedbackTarget, 'Could not open the package popup. Please refresh and try again.', 'is-error');
      return;
    }
    showFeedback(feedbackTarget, 'Choose your JazzCash package from the popup to continue.', 'is-success');
  };

  const routeSubscriptionReturnToProfile = () => {
    const params = new URLSearchParams(window.location.search);
    const awaiting = readAwaitingSubscriptionReturn();
    const stillValidAwaiting = awaiting && awaiting.createdAt && (Date.now() - awaiting.createdAt < 6 * 60 * 60 * 1000);
    const returned = params.get('subscription_return') === '1'
      || (document.referrer && document.referrer.includes('payments.hopshop.pk'))
      || !!stillValidAwaiting;

    if (!returned) return;

    if (!config.customerLoggedIn) return;

    if (window.location.pathname !== (config.profileUrl || '/account')) {
      window.location.href = withPreviewContext(config.profileUrl || '/account', { subscription_return: '1' });
    }
  };

  document.addEventListener('DOMContentLoaded', () => {
    if (config.customerLoggedIn && customerHasActiveTag()) {
      setProActiveState(true);
    }

    routeSubscriptionReturnToProfile();
    syncPreviewAwareAccountLinks();
    initPopup();
    initSubscriptionButtons();
    initMobileForms();
    initCustomerAuthForms();
    initAccountSubscriptionCard();
    handlePendingAfterLogin();
  });
})();